<tr ixTest="header">
  <th *ngFor="let column of displayedColumns; index as idx" (click)="onSort(idx)">
    <div class="title-container" [ngStyle]="{ cursor: column.sortable ? 'pointer' : 'auto' }">
      <div class="title">
        <ng-template
          ix-header-cell
          [dataProvider]="dataProvider"
          [column]="column"
        ></ng-template>
      </div>
      <div *ngIf="column.sortable">
        <ix-icon
          *ngIf="dataProvider.sorting.direction === SortDirection.Asc && dataProvider.sorting.active === idx"
          name="mdi-arrow-down">
        </ix-icon>
        <ix-icon
          *ngIf="dataProvider.sorting.direction === SortDirection.Desc && dataProvider.sorting.active === idx"
          name="mdi-arrow-up">
        </ix-icon>
      </div>
    </div>
  </th>
</tr>
